<script setup>
  import SkeletonLoader from "@components/SkeletonLoader.vue";

  defineOptions({name: "SymptomSkeletonRow"});
</script>

<template>
  <li class="grid animate-pulse grid-cols-12 gap-x-2 border-gray-300 py-2" :data-test="getTestId('skeleton')">
    <SkeletonLoader class-names="m-1 col-span-4 h-[28px]" />
    <SkeletonLoader class-names="m-1 col-span-2 h-[28px]" />
    <SkeletonLoader class-names="m-1 col-span-2 h-[28px]" />
    <SkeletonLoader class-names="m-1 col-span-3 h-[28px]" />
    <SkeletonLoader class-names="m-1 col-span-1 h-[28px]" />
  </li>
</template>
